/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

export interface ScheduleMatch {
    id: string;
    date: string;
    teamA: string;
    teamB: string;
    group: string;
    stadium: string;
    stage: 'groups' | 'round_of_32' | 'round_of_16' | 'quarters' | 'semis' | 'bronze' | 'final';
    matchNumber?: string;
}

export const SHEDULE_DATA: ScheduleMatch[] = [
    // --- Group A ---
    { id: "g_1", date: "Thursday, 11 June 2026 21:00 CET", teamA: "Mexico", teamB: "South Africa", group: "Group A", stadium: "Estadio Azteca", stage: "groups" },
    { id: "g_2", date: "Friday, 12 June 2026 04:00 CET", teamA: "Korea Republic", teamB: "Czechia", group: "Group A", stadium: "Estadio Akron", stage: "groups" },
    { id: "g_3", date: "Thursday, 18 June 2026 18:00 CET", teamA: "Czechia", teamB: "South Africa", group: "Group A", stadium: "Mercedes-Benz Stadium", stage: "groups" },
    { id: "g_4", date: "Friday, 19 June 2026 03:00 CET", teamA: "Mexico", teamB: "Korea Republic", group: "Group A", stadium: "Estadio Akron", stage: "groups" },
    { id: "g_5", date: "Thursday, 25 June 2026 03:00 CET", teamA: "South Africa", teamB: "Korea Republic", group: "Group A", stadium: "Estadio Monterrey", stage: "groups" },
    { id: "g_6", date: "Thursday, 25 June 2026 03:00 CET", teamA: "Czechia", teamB: "Mexico", group: "Group A", stadium: "Estadio Azteca", stage: "groups" },

    // --- Group B ---
    { id: "g_7", date: "Friday, 12 June 2026 21:00 CET", teamA: "Canada", teamB: "Bosnia and Herzegovina", group: "Group B", stadium: "BMO Field", stage: "groups" },
    { id: "g_8", date: "Saturday, 13 June 2026 21:00 CET", teamA: "Qatar", teamB: "Switzerland", group: "Group B", stadium: "Gillette Stadium", stage: "groups" },
    { id: "g_9", date: "Thursday, 18 June 2026 21:00 CET", teamA: "Switzerland", teamB: "Bosnia and Herzegovina", group: "Group B", stadium: "AT&T Stadium", stage: "groups" },
    { id: "g_10", date: "Friday, 19 June 2026 00:00 CET", teamA: "Canada", teamB: "Qatar", group: "Group B", stadium: "BC Place", stage: "groups" },
    { id: "g_11", date: "Wednesday, 24 June 2026 21:00 CET", teamA: "Switzerland", teamB: "Canada", group: "Group B", stadium: "BC Place", stage: "groups" },
    { id: "g_12", date: "Wednesday, 24 June 2026 21:00 CET", teamA: "Bosnia and Herzegovina", teamB: "Qatar", group: "Group B", stadium: "BC Place", stage: "groups" },

    // --- Group C ---
    { id: "g_13", date: "Sunday, 14 June 2026 00:00 CET", teamA: "Brazil", teamB: "Morocco", group: "Group C", stadium: "Gillette Stadium", stage: "groups" },
    { id: "g_14", date: "Sunday, 14 June 2026 03:00 CET", teamA: "Haiti", teamB: "Scotland", group: "Group C", stadium: "Gillette Stadium", stage: "groups" },
    { id: "g_15", date: "Saturday, 20 June 2026 00:00 CET", teamA: "Scotland", teamB: "Morocco", group: "Group C", stadium: "Gillette Stadium", stage: "groups" },
    { id: "g_16", date: "Saturday, 20 June 2026 03:00 CET", teamA: "Brazil", teamB: "Haiti", group: "Group C", stadium: "Gillette Stadium", stage: "groups" },
    { id: "g_17", date: "Thursday, 25 June 2026 00:00 CET", teamA: "Scotland", teamB: "Brazil", group: "Group C", stadium: "Gillette Stadium", stage: "groups" },
    { id: "g_18", date: "Thursday, 25 June 2026 00:00 CET", teamA: "Morocco", teamB: "Haiti", group: "Group C", stadium: "Mercedes-Benz Stadium", stage: "groups" },

    // --- Group D ---
    { id: "g_19", date: "Saturday, 13 June 2026 03:00 CET", teamA: "USA", teamB: "Paraguay", group: "Group D", stadium: "Gillette Stadium", stage: "groups" },
    { id: "g_20", date: "Sunday, 14 June 2026 06:00 CET", teamA: "Australia", teamB: "Türkiye", group: "Group D", stadium: "BC Place", stage: "groups" },
    { id: "g_21", date: "Friday, 19 June 2026 21:00 CET", teamA: "USA", teamB: "Australia", group: "Group D", stadium: "Gillette Stadium", stage: "groups" },
    { id: "g_22", date: "Saturday, 20 June 2026 06:00 CET", teamA: "Türkiye", teamB: "Paraguay", group: "Group D", stadium: "BMO Field", stage: "groups" },
    { id: "g_23", date: "Friday, 26 June 2026 04:00 CET", teamA: "Türkiye", teamB: "USA", group: "Group D", stadium: "Gillette Stadium", stage: "groups" },
    { id: "g_24", date: "Friday, 26 June 2026 04:00 CET", teamA: "Paraguay", teamB: "Australia", group: "Group D", stadium: "BC Place", stage: "groups" },

    // --- Group E ---
    { id: "g_25", date: "Sunday, 14 June 2026 19:00 CET", teamA: "Germany", teamB: "Curaçao", group: "Group E", stadium: "BMO Field", stage: "groups" },
    { id: "g_26", date: "Monday, 15 June 2026 01:00 CET", teamA: "Ivory Coast", teamB: "Ecuador", group: "Group E", stadium: "Gillette Stadium", stage: "groups" },
    { id: "g_27", date: "Saturday, 20 June 2026 22:00 CET", teamA: "Germany", teamB: "Ivory Coast", group: "Group E", stadium: "BMO Field", stage: "groups" },
    { id: "g_28", date: "Sunday, 21 June 2026 02:00 CET", teamA: "Ecuador", teamB: "Curaçao", group: "Group E", stadium: "BMO Field", stage: "groups" },
    { id: "g_29", date: "Thursday, 25 June 2026 21:00 CET", teamA: "Curaçao", teamB: "Ivory Coast", group: "Group E", stadium: "Gillette Stadium", stage: "groups" },
    { id: "g_30", date: "Thursday, 25 June 2026 22:00 CET", teamA: "Ecuador", teamB: "Germany", group: "Group E", stadium: "Gillette Stadium", stage: "groups" },

    // --- Group F ---
    { id: "g_31", date: "Sunday, 14 June 2026 22:00 CET", teamA: "Netherlands", teamB: "Japan", group: "Group F", stadium: "AT&T Stadium", stage: "groups" },
    { id: "g_32", date: "Monday, 15 June 2026 04:00 CET", teamA: "Sweden", teamB: "Tunisia", group: "Group F", stadium: "Estadio BBVA", stage: "groups" },
    { id: "g_33", date: "Saturday, 20 June 2026 19:00 CET", teamA: "Netherlands", teamB: "Sweden", group: "Group F", stadium: "AT&T Stadium", stage: "groups" },
    { id: "g_34", date: "Sunday, 21 June 2026 06:00 CET", teamA: "Tunisia", teamB: "Japan", group: "Group F", stadium: "Estadio Monterrey", stage: "groups" },
    { id: "g_35", date: "Friday, 26 June 2026 01:00 CET", teamA: "Tunisia", teamB: "Netherlands", group: "Group F", stadium: "AT&T Stadium", stage: "groups" },
    { id: "g_36", date: "Friday, 26 June 2026 01:00 CET", teamA: "Japan", teamB: "Sweden", group: "Group F", stadium: "AT&T Stadium", stage: "groups" },

    // --- Group G ---
    { id: "g_37", date: "Monday, 15 June 2026 21:00 CET", teamA: "Belgium", teamB: "Egypt", group: "Group G", stadium: "BC Place", stage: "groups" },
    { id: "g_38", date: "Tuesday, 16 June 2026 03:00 CET", teamA: "IR Iran", teamB: "New Zealand", group: "Group G", stadium: "Mercedes-Benz Stadium", stage: "groups" },
    { id: "g_39", date: "Sunday, 21 June 2026 21:00 CET", teamA: "Belgium", teamB: "IR Iran", group: "Group G", stadium: "Mercedes-Benz Stadium", stage: "groups" },
    { id: "g_40", date: "Monday, 22 June 2026 03:00 CET", teamA: "New Zealand", teamB: "Egypt", group: "Group G", stadium: "BC Place", stage: "groups" },
    { id: "g_41", date: "Saturday, 27 June 2026 05:00 CET", teamA: "New Zealand", teamB: "Belgium", group: "Group G", stadium: "BC Place", stage: "groups" },
    { id: "g_42", date: "Saturday, 27 June 2026 05:00 CET", teamA: "Egypt", teamB: "IR Iran", group: "Group G", stadium: "BC Place", stage: "groups" },

    // --- Group H ---
    { id: "g_43", date: "Monday, 15 June 2026 18:00 CET", teamA: "Spain", teamB: "Cabo Verde", group: "Group H", stadium: "Mercedes-Benz Stadium", stage: "groups" },
    { id: "g_44", date: "Tuesday, 16 June 2026 00:00 CET", teamA: "Saudi Arabia", teamB: "Uruguay", group: "Group H", stadium: "Gillette Stadium", stage: "groups" },
    { id: "g_45", date: "Sunday, 21 June 2026 18:00 CET", teamA: "Spain", teamB: "Saudi Arabia", group: "Group H", stadium: "Mercedes-Benz Stadium", stage: "groups" },
    { id: "g_46", date: "Monday, 22 June 2026 00:00 CET", teamA: "Uruguay", teamB: "Cabo Verde", group: "Group H", stadium: "Mercedes-Benz Stadium", stage: "groups" },
    { id: "g_47", date: "Saturday, 27 June 2026 02:00 CET", teamA: "Saudi Arabia", teamB: "Cabo Verde", group: "Group H", stadium: "Estadio Monterrey", stage: "groups" },
    { id: "g_48", date: "Saturday, 27 June 2026 02:00 CET", teamA: "Uruguay", teamB: "Spain", group: "Group H", stadium: "Estadio Akron", stage: "groups" },

    // --- Group I ---
    { id: "g_49", date: "Tuesday, 16 June 2026 21:00 CET", teamA: "France", teamB: "Senegal", group: "Group I", stadium: "Gillette Stadium", stage: "groups" },
    { id: "g_50", date: "Wednesday, 17 June 2026 00:00 CET", teamA: "Iraq", teamB: "Norway", group: "Group I", stadium: "Gillette Stadium", stage: "groups" },
    { id: "g_51", date: "Monday, 22 June 2026 23:00 CET", teamA: "France", teamB: "Iraq", group: "Group I", stadium: "Gillette Stadium", stage: "groups" },
    { id: "g_52", date: "Tuesday, 23 June 2026 02:00 CET", teamA: "Senegal", teamB: "Norway", group: "Group I", stadium: "Gillette Stadium", stage: "groups" },
    { id: "g_53", date: "Friday, 26 June 2026 21:00 CET", teamA: "Senegal", teamB: "Iraq", group: "Group I", stadium: "BMO Field", stage: "groups" },
    { id: "g_54", date: "Friday, 26 June 2026 21:00 CET", teamA: "Norway", teamB: "France", group: "Group I", stadium: "Gillette Stadium", stage: "groups" },

    // --- Group J ---
    { id: "g_55", date: "Wednesday, 17 June 2026 03:00 CET", teamA: "Argentina", teamB: "Algeria", group: "Group J", stadium: "Estadio Azteca", stage: "groups" },
    { id: "g_56", date: "Wednesday, 17 June 2026 06:00 CET", teamA: "Austria", teamB: "Jordan", group: "Group J", stadium: "Estadio Akron", stage: "groups" },
    { id: "g_57", date: "Monday, 22 June 2026 19:00 CET", teamA: "Argentina", teamB: "Austria", group: "Group J", stadium: "AT&T Stadium", stage: "groups" },
    { id: "g_58", date: "Tuesday, 23 June 2026 05:00 CET", teamA: "Algeria", teamB: "Jordan", group: "Group J", stadium: "Estadio Azteca", stage: "groups" },
    { id: "g_59", date: "Sunday, 28 June 2026 04:00 CET", teamA: "Algeria", teamB: "Austria", group: "Group J", stadium: "Estadio Azteca", stage: "groups" },
    { id: "g_60", date: "Sunday, 28 June 2026 04:00 CET", teamA: "Argentina", teamB: "Jordan", group: "Group J", stadium: "AT&T Stadium", stage: "groups" },

    // --- Group K ---
    { id: "g_61", date: "Wednesday, 17 June 2026 19:00 CET", teamA: "Portugal", teamB: "Congo DR", group: "Group K", stadium: "Estadio BBVA", stage: "groups" },
    { id: "g_62", date: "Thursday, 18 June 2026 04:00 CET", teamA: "Uzbekistan", teamB: "Colombia", group: "Group K", stadium: "Estadio Azteca", stage: "groups" },
    { id: "g_63", date: "Tuesday, 23 June 2026 19:00 CET", teamA: "Portugal", teamB: "Uzbekistan", group: "Group K", stadium: "Estadio BBVA", stage: "groups" },
    { id: "g_64", date: "Wednesday, 24 June 2026 04:00 CET", teamA: "Congo DR", teamB: "Colombia", group: "Group K", stadium: "Estadio Guadalajara", stage: "groups" },
    { id: "g_65", date: "Sunday, 28 June 2026 01:30 CET", teamA: "Colombia", teamB: "Portugal", group: "Group K", stadium: "Estadio BBVA", stage: "groups" },
    { id: "g_66", date: "Sunday, 28 June 2026 01:30 CET", teamA: "Congo DR", teamB: "Uzbekistan", group: "Group K", stadium: "Mercedes-Benz Stadium", stage: "groups" },

    // --- Group L ---
    { id: "g_67", date: "Wednesday, 17 June 2026 22:00 CET", teamA: "England", teamB: "Croatia", group: "Group L", stadium: "AT&T Stadium", stage: "groups" },
    { id: "g_68", date: "Thursday, 18 June 2026 01:00 CET", teamA: "Ghana", teamB: "Panama", group: "Group L", stadium: "BMO Field", stage: "groups" },
    { id: "g_69", date: "Tuesday, 23 June 2026 22:00 CET", teamA: "England", teamB: "Ghana", group: "Group L", stadium: "Gillette Stadium", stage: "groups" },
    { id: "g_70", date: "Wednesday, 24 June 2026 01:00 CET", teamA: "Croatia", teamB: "Panama", group: "Group L", stadium: "BMO Field", stage: "groups" },
    { id: "g_71", date: "Saturday, 27 June 2026 23:00 CET", teamA: "England", teamB: "Panama", group: "Group L", stadium: "Gillette Stadium", stage: "groups" },
    { id: "g_72", date: "Saturday, 27 June 2026 23:00 CET", teamA: "Croatia", teamB: "Ghana", group: "Group L", stadium: "Gillette Stadium", stage: "groups" },

    // --- ROUND OF 32 ---
    { id: "r32_1", date: "Sunday, 28 June 2026", teamA: "Group A runners-up", teamB: "Group B runners-up", group: "Round of 32", stadium: "Gillette Stadium", stage: "round_of_32", matchNumber: "Match 73" },
    { id: "r32_2", date: "Monday, 29 June 2026", teamA: "Group E winners", teamB: "Group A/B/C/D/F third place", group: "Round of 32", stadium: "Gillette Stadium", stage: "round_of_32", matchNumber: "Match 74" },
    { id: "r32_3", date: "Monday, 29 June 2026", teamA: "Group F winners", teamB: "Group C runners-up", group: "Round of 32", stadium: "Estadio Monterrey", stage: "round_of_32", matchNumber: "Match 75" },
    { id: "r32_4", date: "Monday, 29 June 2026", teamA: "Group C winners", teamB: "Group F runners-up", group: "Round of 32", stadium: "AT&T Stadium", stage: "round_of_32", matchNumber: "Match 76" },
    { id: "r32_5", date: "Tuesday, 30 June 2026", teamA: "Group I winners", teamB: "Group C/D/F/G/H third place", group: "Round of 32", stadium: "Gillette Stadium", stage: "round_of_32", matchNumber: "Match 77" },
    { id: "r32_6", date: "Tuesday, 30 June 2026", teamA: "Group E runners up", teamB: "Group I runners-up", group: "Round of 32", stadium: "AT&T Stadium", stage: "round_of_32", matchNumber: "Match 78" },
    { id: "r32_7", date: "Tuesday, 30 June 2026", teamA: "Group A winners", teamB: "Group C/E/F/H/I third place", group: "Round of 32", stadium: "Estadio Azteca", stage: "round_of_32", matchNumber: "Match 79" },
    { id: "r32_8", date: "Wednesday, 1 July 2026", teamA: "Group L winners", teamB: "Group E/H/I/J/K third place", group: "Round of 32", stadium: "Mercedes-Benz Stadium", stage: "round_of_32", matchNumber: "Match 80" },
    { id: "r32_9", date: "Wednesday, 1 July 2026", teamA: "Group D winners", teamB: "Group B/E/F/I/J third place", group: "Round of 32", stadium: "Gillette Stadium", stage: "round_of_32", matchNumber: "Match 81" },
    { id: "r32_10", date: "Wednesday, 1 July 2026", teamA: "Group G winners", teamB: "Group A/E/H/I/J third place", group: "Round of 32", stadium: "BC Place", stage: "round_of_32", matchNumber: "Match 82" },
    { id: "r32_11", date: "Thursday, 2 July 2026", teamA: "Group K runners-up", teamB: "Group L runners-up", group: "Round of 32", stadium: "BMO Field", stage: "round_of_32", matchNumber: "Match 83" },
    { id: "r32_12", date: "Thursday, 2 July 2026", teamA: "Group H winners", teamB: "Group J runners-up", group: "Round of 32", stadium: "Gillette Stadium", stage: "round_of_32", matchNumber: "Match 84" },
    { id: "r32_13", date: "Thursday, 2 July 2026", teamA: "Group B winners", teamB: "Group E/F/G/I/J third place", group: "Round of 32", stadium: "BC Place", stage: "round_of_32", matchNumber: "Match 85" },
    { id: "r32_14", date: "Friday, 3 July 2026", teamA: "Group J winners", teamB: "Group H runners-up", group: "Round of 32", stadium: "Mercedes-Benz Stadium", stage: "round_of_32", matchNumber: "Match 86" },
    { id: "r32_15", date: "Friday, 3 July 2026", teamA: "Group K winners", teamB: "Group D/E/I/J/L third place", group: "Round of 32", stadium: "BMO Field", stage: "round_of_32", matchNumber: "Match 87" },
    { id: "r32_16", date: "Friday, 3 July 2026", teamA: "Group D runners-up", teamB: "Group G runners-up", group: "Round of 32", stadium: "AT&T Stadium", stage: "round_of_32", matchNumber: "Match 88" },

    // --- ROUND OF 16 ---
    { id: "r16_1", date: "Saturday, 4 July 2026", teamA: "Winner match 74", teamB: "Winner match 77", group: "Round of 16", stadium: "Gillette Stadium", stage: "round_of_16", matchNumber: "Match 89" },
    { id: "r16_2", date: "Saturday, 4 July 2026", teamA: "Winner match 73", teamB: "Winner match 75", group: "Round of 16", stadium: "Gillette Stadium", stage: "round_of_16", matchNumber: "Match 90" },
    { id: "r16_3", date: "Sunday, 5 July 2026", teamA: "Winner match 76", teamB: "Winner match 78", group: "Round of 16", stadium: "Gillette Stadium", stage: "round_of_16", matchNumber: "Match 91" },
    { id: "r16_4", date: "Sunday, 5 July 2026", teamA: "Winner match 79", teamB: "Winner match 80", group: "Round of 16", stadium: "Estadio Azteca", stage: "round_of_16", matchNumber: "Match 92" },
    { id: "r16_5", date: "Monday, 6 July 2026", teamA: "Winner match 83", teamB: "Winner match 84", group: "Round of 16", stadium: "AT&T Stadium", stage: "round_of_16", matchNumber: "Match 93" },
    { id: "r16_6", date: "Monday, 6 July 2026", teamA: "Winner match 81", teamB: "Winner match 82", group: "Round of 16", stadium: "BC Place", stage: "round_of_16", matchNumber: "Match 94" },
    { id: "r16_7", date: "Tuesday, 7 July 2026", teamA: "Winner match 86", teamB: "Winner match 88", group: "Round of 16", stadium: "Mercedes-Benz Stadium", stage: "round_of_16", matchNumber: "Match 95" },
    { id: "r16_8", date: "Tuesday, 7 July 2026", teamA: "Winner match 85", teamB: "Winner match 87", group: "Round of 16", stadium: "BC Place", stage: "round_of_16", matchNumber: "Match 96" },

    // --- QUARTER FINALS ---
    { id: "qf_1", date: "Thursday, 9 July 2026", teamA: "Winner match 89", teamB: "Winner match 90", group: "Quarter-Finals", stadium: "Gillette Stadium", stage: "quarters", matchNumber: "Match 97" },
    { id: "qf_2", date: "Friday, 10 July 2026", teamA: "Winner match 93", teamB: "Winner match 94", group: "Quarter-Finals", stadium: "Gillette Stadium", stage: "quarters", matchNumber: "Match 98" },
    { id: "qf_3", date: "Saturday, 11 July 2026", teamA: "Winner match 91", teamB: "Winner match 92", group: "Quarter-Finals", stadium: "Gillette Stadium", stage: "quarters", matchNumber: "Match 99" },
    { id: "qf_4", date: "Saturday, 11 July 2026", teamA: "Winner match 95", teamB: "Winner match 96", group: "Quarter-Finals", stadium: "Gillette Stadium", stage: "quarters", matchNumber: "Match 100" },

    // --- SEMI FINALS ---
    { id: "sf_1", date: "Tuesday, 14 July 2026", teamA: "Winner match 97", teamB: "Winner match 98", group: "Semi-Finals", stadium: "AT&T Stadium", stage: "semis", matchNumber: "Match 101" },
    { id: "sf_2", date: "Wednesday, 15 July 2026", teamA: "Winner match 99", teamB: "Winner match 100", group: "Semi-Finals", stadium: "Mercedes-Benz Stadium", stage: "semis", matchNumber: "Match 102" },

    // --- BRONZE FINAL ---
    { id: "bf_1", date: "Saturday, 18 July 2026", teamA: "Runner-up match 101", teamB: "Runner-up match 102", group: "Bronze Final", stadium: "Gillette Stadium", stage: "bronze", matchNumber: "Match 103" },

    // --- FINAL ---
    { id: "f_1", date: "Sunday, 19 July 2026", teamA: "Winner match 101", teamB: "Winner match 102", group: "World Cup Final", stadium: "Estadio Azteca", stage: "final", matchNumber: "Match 104" }
];

export const parseMatchDateStringToDate = (dateStr: string): Date => {
    try {
        let clean = dateStr.replace(/^[A-Za-z]+,\s*/, '').trim();
        const isCet = clean.toUpperCase().includes('CET') || clean.toUpperCase().includes('CEST');
        clean = clean.replace(/\s*CET\s*$/i, '').replace(/\s*CEST\s*$/i, '').trim();

        const parts = clean.split(/\s+/);
        if (parts.length >= 3) {
            const day = parseInt(parts[0], 10);
            const monthName = parts[1].toLowerCase();
            const year = parseInt(parts[2], 10);

            const months: Record<string, number> = {
                january: 0, jan: 0,
                february: 1, feb: 1,
                march: 2, mar: 2,
                april: 3, apr: 3,
                may: 4,
                june: 5, jun: 5,
                july: 6, jul: 6,
                august: 7, aug: 7,
                september: 8, sep: 8,
                october: 9, oct: 9,
                november: 10, nov: 10,
                december: 11, dec: 11
            };

            const month = months[monthName] !== undefined ? months[monthName] : 5;

            let hours = 18;
            let minutes = 0;
            if (parts[3] && parts[3].includes(':')) {
                const timeParts = parts[3].split(':');
                hours = parseInt(timeParts[0], 10);
                minutes = parseInt(timeParts[1], 10);
            }

            const isDst = (month >= 2 && month <= 9); // April to October roughly DST in Europe
            const cetOffsetHours = isDst ? 2 : 1;

            if (isCet) {
                const utcTime = Date.UTC(year, month, day, hours, minutes, 0);
                return new Date(utcTime - (cetOffsetHours * 60 * 60 * 1000));
            } else {
                return new Date(year, month, day, hours, minutes, 0);
            }
        }
    } catch {}
    return new Date(dateStr);
};

// Deterministic match outcome generator based on matchId
export function getDeterministicMatchResult(matchId: string) {
    if (matchId === "g_7") {
        return {
            actualScoreA: 1,
            actualScoreB: 1,
            actualCorners: 8,
            actualOverUnder: 'under'
        };
    }

    let seed = 0;
    for (let i = 0; i < matchId.length; i++) {
        seed += matchId.charCodeAt(i);
    }
    const pseudoRandom = (offset: number) => {
        const x = Math.sin(seed + offset) * 10000;
        return x - Math.floor(x);
    };

    // Score A: 0 - 3
    const actualScoreA = Math.floor(pseudoRandom(1) * 4);
    // Score B: 0 - 3
    const actualScoreB = Math.floor(pseudoRandom(2) * 4);
    // Corners: 4 - 11
    const actualCorners = Math.floor(pseudoRandom(3) * 8) + 4;
    const actualOverUnder = (actualScoreA + actualScoreB) > 2.5 ? 'over' : 'under';

    return {
        actualScoreA,
        actualScoreB,
        actualCorners,
        actualOverUnder
    };
}

// Deterministic mock Match Statistics generator based on game parameters and seed
export function getMatchStats(matchId: string, actualScoreA: number, actualScoreB: number, actualCorners: number) {
    let seed = 0;
    for (let i = 0; i < matchId.length; i++) {
        seed += matchId.charCodeAt(i);
    }
    const pseudoRandom = (offset: number) => {
        const x = Math.sin(seed + offset) * 10000;
        return x - Math.floor(x);
    };

    // Possession A: 40% - 60%
    const posA = Math.floor(pseudoRandom(1) * 20) + 40;
    const posB = 100 - posA;

    // Shots on target (must be at least goals scored)
    const sTargetA = actualScoreA + Math.floor(pseudoRandom(2) * 4) + 1;
    const sTargetB = actualScoreB + Math.floor(pseudoRandom(3) * 4) + 1;

    // Total Shots
    const sTotalA = sTargetA + Math.floor(pseudoRandom(4) * 7) + 2;
    const sTotalB = sTargetB + Math.floor(pseudoRandom(5) * 7) + 2;

    // Passing Accuracy
    const passA = Math.floor(pseudoRandom(6) * 12) + 78;
    const passB = Math.floor(pseudoRandom(7) * 12) + 76;

    // Fouls
    const foulsA = Math.floor(pseudoRandom(8) * 6) + 7;
    const foulsB = Math.floor(pseudoRandom(9) * 6) + 8;

    // Yellow Cards
    const yellowA = Math.floor(pseudoRandom(10) * 3);
    const yellowB = Math.floor(pseudoRandom(11) * 3);

    // Red Cards
    const redA = pseudoRandom(12) < 0.05 ? 1 : 0;
    const redB = pseudoRandom(13) < 0.05 ? 1 : 0;

    // Corners distribution from overall corners
    const cornersA = Math.min(actualCorners, Math.floor(actualCorners * (posA / 100) + pseudoRandom(14) * 1.5));
    const cornersB = Math.max(0, actualCorners - cornersA);

    return {
        possession: [posA, posB],
        shotsTarget: [sTargetA, sTargetB],
        shotsTotal: [sTotalA, sTotalB],
        passing: [passA, passB],
        fouls: [foulsA, foulsB],
        yellow: [yellowA, yellowB],
        red: [redA, redB],
        corners: [cornersA, cornersB]
    };
}

